<!-- @format -->
<script lang="ts">
  import { getStoresContext } from "~/stores";
  import { convertTimeToReadable, getDay, today } from "../../utils";
  import { sortMenuItemsByDay } from "./utils";
  import type { ManageAPI } from "~/manage-api/types";
  import type { StoresKey } from "~/stores";
  import { displayFloor } from "../store/utils";

  export let item: ManageAPI.Lunch;
  export let request_store_key: StoresKey;
  export let activeDay: number;

  const { stores, locale, T } = getStoresContext(request_store_key);

  // Find store by exact ID match
  $: storeIdToFind = item.store.id;
  $: store = $stores.find(store => store.id === storeIdToFind);
  $: if (!store) {
    console.error(`Store ID mismatch: No store found for ID ${storeIdToFind} (${item.store.name})`);
  }

  $: t = $T;
  $: floorDesc = displayFloor(store, t);
  $: sortedMenuItems = sortMenuItemsByDay(item, $locale);
  $: todayMenuItems = sortedMenuItems.filter(
    (menu: ManageAPI.DailyLunchMenu) => getDay(menu.day) === activeDay
  );

  function getImageUrl(store: ManageAPI.Store) {
    return store?.logoURL || "";
  }
</script>

<div class="row mb-7">
  <div class="col-lg-5 col-12">
    <div class="d-lg-flex">
      <div class="square border mb-lg-0 mb-3">
        {#if store && getImageUrl(store)}
          <img class="store-logo" src={getImageUrl(store)} alt={item.store.name} />
        {:else}
          <div class="no-logo d-flex align-items-center justify-content-center">
            {item.store.name}
          </div>
        {/if}
      </div>
      <div class="store-info pl-lg-5 position-relative">
        <div class="store-name">{item.store.name}</div>
        <div class="text-gray floor mb-3">{floorDesc || ''}</div>
        {#if store}
          <div class="open-today">
            {t`today`}: <strong>{today(store, t)}</strong>
          </div>
        {/if}
      </div>
    </div>
  </div>
  <div class="col-lg-6 col-12 lunchMenu">
    {#if item.lunchTime}
      <p class="lunch-time">{t`lunch time`}: {item.lunchTime}</p>
    {/if}
    {#each todayMenuItems as menuItem}
      <div class="menu-item">
        <div class="lunchcontent">
          {@html menuItem.lunchMenu}
        </div>
      </div>
    {/each}
  </div>
</div>

<style lang="scss">
  .floor {
    font-size: 16px;
  }
  
  .store-name {
    font-weight: 500;
    font-size: 20px;
    line-height: 130%;
    letter-spacing: -0.02em;

    @media screen and (min-width: 768px) {
      font-size: 22px;
    }

    @media screen and (min-width: 1280px) {
      font-size: 24px;
    }
  }
  
  .store-info {
    display: flex;
    flex-direction: column;
    min-height: 120px;
  }
  
  .open-today {
    font-size: 16px;
    margin-top: auto;
    
    @media only screen and (min-width: 992px) {
      margin-top: auto;
    }
  }
  
  .store-logo {
    max-width: 90%;
    max-height: 90%;
    object-fit: contain;
  }
  
  .no-logo {
    width: 90%;
    height: 90%;
    text-align: center;
    font-weight: bold;
    color: #555;
    font-size: 14px;
  }

  .square {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 120px;
    height: 120px;
    min-width: 120px;
    border: 1px solid #e0e0e0;
  }
  
  .lunchMenu {
    font-size: 20px;
    line-height: 150%;
    
    @media screen and (min-width: 768px) {
      font-size: 22px;
    }
  }
  
  .lunch-time {
    margin-bottom: 1rem;
  }
  
  .menu-item {
    margin-bottom: 1rem;
  }
  
  .lunchcontent {
    white-space: pre-wrap;
    
    :global(div) {
      margin-top: 1rem;
    }
    :global(div:first-child) {
      margin-top: 0;
    }
  }
  
  .text-gray {
    color: #666;
  }
  
  .pl-lg-5 {
    @media screen and (min-width: 992px) {
      padding-left: 3rem;
    }
  }
</style>

